import { store } from 'store/store';

export const getActivePage = (pageId: number): StepBlock => {
	const contentAreas = store.getState().pages.contentArea;
	let stepBlock: StepBlock;
	Object.keys(contentAreas).forEach((area) => {
		if (!stepBlock && contentAreas[area]?.content?.activePages?.length > 0) {
			contentAreas[area].content.activePages.forEach((step) => {
				if (step.contentId === pageId) {
					stepBlock = { ...step }; // copy
				}
			});
		}
	});
	return stepBlock;
};

export const loadDefaultsToForm = (metaArea: MetaArea, onSubmit: (values) => void) => {
	const calculationOptions = metaArea.items?.[0]?.content?.calculationOptions;
	const loadFormValues = {};
	for (const calculationOption of calculationOptions?.items ?? []) {
		if (calculationOption.content?.contentType === 'CalculationOptionsBlock') {
			loadModalFieldsToForm(calculationOption, loadFormValues);
		} else if (calculationOption.content?.contentType === 'HiddenFieldBlock') {
			loadHiddenFieldToForm(calculationOption, loadFormValues);
		} else {
			console.warn('Unsupported calculation option content type', calculationOption.content?.contentType);
		}
	}
	onSubmit(loadFormValues);
};

const loadModalFieldsToForm = (calculationOption, loadFormValues): void => {
	for (const f of calculationOption?.content?.modal?.fields?.items ?? []) {
		const field = f?.content;
		// Only supporting SelectFieldBlock for now, can be extended to support other field types as needed
		if (field?.contentType === 'SelectFieldBlock') {
			const id = field.uniqueIdentifier?.uid;
			const defaultOption =
				field.chosenOption === undefined ? { ...field.options[0] } : { ...field.options[field.chosenOption] };
			loadFormValues[id] = {
				id,
				value: defaultOption.value,
				label: defaultOption.key,
				stepTitle: 'NAME_NOT_PROVIDED',
				type: field.contentType,
			};
		}
	}
};

const loadHiddenFieldToForm = (calculationOption, loadFormValues): void => {
	const field = calculationOption.content;
	const id = field?.uniqueIdentifier?.uid;
	if (id) {
		loadFormValues[id] = {
			id,
			value: field?.defaultValue,
			label: field?.defaultValue,
			stepTitle: 'NAME_NOT_PROVIDED',
			type: field.contentType,
		};
	}
};
